import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

const DialogPrompt = ({
  openPrompt,
  content,
  title,
  button1,
  button1Click,
  button2Click,
  button2,
}) => {
  const [, setOpen] = useState<boolean>(false);

  const handlePromptClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Dialog open={openPrompt} onClose={handlePromptClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={button1Click}>
            {button1}
          </Button>
          <Button onClick={button2Click}>{button2}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogPrompt;
